import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import curved9 from "assets/images/o4.png";
import toast from "react-hot-toast";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { baseURL } from 'utils/api';
// import OTP from "./otp";
import Reset from "./reset";

function SignIn() {

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [email, setEmail] = useState("");
  const [show, setShow] = useState(false);
  const [oldOtp, setOldOtp] = useState('');


  const HandleSignIn = () => {
    if (!email) {
      return toast.error("Email is missing");
    }
    if (!email.includes("@") || !email.includes(".")) {
      return toast.error("Invalid email");
    }

    fetch(`${baseURL}/forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    }).then((res) => res.json())
      .then((resp) => {
        if (resp.status === 200) {
          navigate("/login")
          return toast.success(resp?.message);
        }
        if (!resp.success) {
          return toast.error(resp.error || resp?.message);
        }
      }).catch((err) => {
        return toast.error(err.message);
      });
  };

  return (
    <CoverLayout
      title={"Reset Password"}
      description={"Enter your email  to reset your password"}
      image={curved9}
      forgot={true}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Email
            </SoftTypography>
          </SoftBox>

          <SoftInput
            required={true}
            placeholder="Enter email"
            onWheel={(e) => e.target.blur()}
            name="email"
            maxLength={10}
            type="text"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            onClick={() => HandleSignIn()}
            variant="gradient" color="info" fullWidth>
            Submit
          </SoftButton>
        </SoftBox></SoftBox>
      {show == 2 && <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <OTP email={email} oldOtp={oldOtp} setOldOtp={setOldOtp} setShow={setShow} />
          </SoftBox>
        </SoftBox>
      </SoftBox>}

      {
        show == 3 && <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <Reset email={email} setShow={setShow} />
            </SoftBox>
          </SoftBox>
        </SoftBox>

      }


      <SoftBox mt={3} textAlign="center" >
        <SoftTypography variant="button" color="text" fontWeight="regular">
          Already have an account?{" "}
          <SoftTypography
            component={Link}
            to="/login"
            variant="button"
            color="info"
            fontWeight="medium"
            textGradient
          >
            Sign in
          </SoftTypography>
        </SoftTypography>
      </SoftBox>



    </CoverLayout>
  );
}

export default SignIn;
